import json from "./json";
import {isShift4Origin, JS_ORIGIN, SHIFT4_JS_ORIGIN} from "../securionpayOrigins";
import {DEBUG_POST_MESSAGE} from "../env";
import {actionMatches} from "../utils/actionMatches";
import urls from "../urls";

const windowOrigin = urls.getOrigin(window.location.href);

const NON_CONFIDENTIAL_ACTIONS = ['controller-load', 'user-action-complete'];

const isNonConfidentialMessage = function (message) {
    return NON_CONFIDENTIAL_ACTIONS.some(action => actionMatches(message.message, action))
};

const getOrigin = function (message) {
    if (isNonConfidentialMessage(message)) {
        return "*";
    }
    if (isShift4Origin(windowOrigin)) {
        return SHIFT4_JS_ORIGIN;
    }
    return JS_ORIGIN;
};

const debugPostMessage = (...opts) => DEBUG_POST_MESSAGE && console.log(...opts)

export default {
    parentPostMessage: (message, targetOrigin = "*") => {
        let windowTarget = window.opener || window.parent || window;
        const messageJson = json.stringify(message);
        debugPostMessage(`${window.name} sending message to parent (${targetOrigin})`, messageJson, windowTarget);
        windowTarget.postMessage(messageJson, targetOrigin);
    },

    framePostMessage: (message) => {
        const frameId = message.type === "controller" ? message.controllerId : message.frameId;
        const frame = window.frames[frameId] || window.parent.frames[frameId] || window?.top?.[0]?.frames?.[frameId];
        const messageJson = json.stringify(message);
        const origin = getOrigin(message);

        if (frame) {
            debugPostMessage(`${window.name} sending message to ${frameId} (${origin})`, messageJson, frame);
            frame.postMessage(messageJson, origin);
        } else {
            debugPostMessage(`${window.name} doesn't have frame with id: ${frameId} (${origin}`, messageJson);
        }
    }
}
